



























































import Vue from 'vue';
import gql from 'graphql-tag';
import { mapActions } from 'vuex';
import GenericCard from '@/components/cards/GenericCard.vue';
import ItemStatusIndicator from '@/components/editable_label/ItemStatusIndicator.vue';
import { ModalSize } from '@/components/zen_modal/types';
import ZenTable from '@/components/listing/ZenTable.vue';

export default Vue.extend({
  name: 'CalculateReport',
  components: {
    ZenTable,
    GenericCard,
    ItemStatusIndicator,
  },
  props: {
    updated: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      confirmed: false,
      columns: [],
      scoreTitles: {},
      fullyUpdated: [],
      partiallyUpdated: [],
      notUpdated: [],
      indicatorStatuses: [
        {
          status: 'fullyUpdated',
          hint: 'Fully updated',
          color: '#3bbf74',
        },
        {
          status: 'partiallyUpdated',
          hint: 'Partially updated',
          color: '#ffac1f',
        },
        {
          status: 'notUpdated',
          hint: 'Not updated',
          color: '#ef4853',
        },
      ],
    };
  },
  computed: {
    fullyUpdatedRisks() {
      return this.generateList(this.fullyUpdated);
    },
    partiallyUpdatedRisks() {
      return this.generateList(this.partiallyUpdated);
    },
    notUpdatedRisks() {
      return this.generateList(this.notUpdated);
    },
  },
  created() {
    this.changeModalSize(ModalSize.Large);
    for (const risk of this.updated) {
      var vectorScoreValues = risk.vectorScoreValues.map(vectorScoreValue => vectorScoreValue.value);
      if (!vectorScoreValues.includes(null)) {
        this.fullyUpdated.push(risk);
      } else if (vectorScoreValues.every(item => item == null)) {
        this.notUpdated.push(risk);
      } else {
        this.partiallyUpdated.push(risk);
      }
    }
    this.loading = false;
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
    }),
    generateList(risks) {
      return risks.map(risk => {
        return {
          id: risk.id,
          title: risk.title,
          url: `/sor/info/Risk/${risk.id}/info`,
          riskScores: risk.vectorScoreValues.map(vectorScoreValue => {
            return {
              title: 'score_' + vectorScoreValue.vectorScoreId,
              score: vectorScoreValue.value,
            };
          }),
        };
      });
    },
  },
  apollo: {
    columns: {
      query: gql`
        query ScoreIds($filter: JSONString) {
          search(type: RiskVectorScore, filter: $filter) {
            edges {
              node {
                ... on RiskVectorScore {
                  dbId
                  title {
                    value
                  }
                }
              }
            }
          }
        }
      `,
      variables() {
        let filter = {
          left: 'formula_type',
          op: {
            name: '=',
          },
          right: 'Score',
        };
        return {
          filter: JSON.stringify(filter),
        };
      },
      update(result) {
        const scoreColumns = result.search.edges.map(function(score) {
          return {
            key: 'score_' + score.node.dbId,
            label: score.node.title.value,
            presenter: 'RiskScores',
            id: score.node.dbId,
          };
        });
        const columns = [{ key: 'title', presenter: 'RiskTitle', label: 'Title' }].concat(scoreColumns);
        return columns;
      },
    },
  },
});
